<template>
    <div class="p-14 flex flex-col items-center justify-center">
        <AddEmailIcon class="mb-8"/>

        <p class="text-body-5 font-medium text-default-1 mb-3">
            Add <span> new email</span>
        </p>

        <p class="text-body-6 text-default-1 text-center mb-6">
            After entering the email, there will be a verification process
        </p>

        <CoreInput
                type="text"
                class="mb-8 w-full"
                v-model="email.value.value"
                :has-error="!!emailError.email"
                :hint-text="emailError.email"
                @input="resetAllErrors"
        />

        <CoreButton
                buttonType="primary"
                label="Send verification code"
                size="default"
                @click="sendCode"
                @keyup.enter="sendCode"
                :loading="buttonLoader"
                :disabled="!!emailError.email || !meta.valid"
        />
    </div>
</template>

<script setup>
import CoreButton from '@/components/core/Button.vue';
import AddEmailIcon from '@/components/icons/email/Add.vue';
import CoreInput from '@/components/core/InputGroup.vue';
import {useOnboarding} from "@/stores/OnboardingStore";
import {computed, defineEmits, onMounted} from "vue";
import {useField, useForm} from "vee-validate";
import * as yup from "yup";

const emit = defineEmits(['sendCode']);
const props = defineProps({
    buttonLoader: {
        type: Boolean,
        default: false,
    }
})

const {errors: onBoardingErrors, resetAllErrors} = useOnboarding();

const {meta} = useForm({
    initialValues: {
        email: '',
    },
});

const email = useField('email', yup.string().required().email().label('The email address'));

const emailError = computed(() => {
    return {
        email: onBoardingErrors.new_email ?? (email.errorMessage.value ?? null)
    };
});


function sendCode() {
    resetAllErrors();

    if (!meta.value.valid) {
        return
    }

    emit('sendCode', email.value.value);
}

onMounted(() => {
    resetAllErrors();
})
</script>
